<template>
    <v-container fluid tag="section" class="indicator-container">
        <v-row>
            <v-col cols="12" md="8">
                <v-tabs color="primary" style="background-color: #FFFFFF; padding: 5px 0px 10px 5px;">
                    <v-tab v-for="(tab, i) in tabsOrg" :key="i" :to="tab.to">{{ tab.text }}</v-tab>
                </v-tabs>
            </v-col>
        </v-row>
        <indicator-table
            :groups="groups"
            :groupList="groupList"
        />
    </v-container>
</template>

<script>
import { OrganizationMachineTabMenu } from "@/pages/organization-machine/organizationContant.js"
import IndicatorTable  from './components/IndicatorTable'
import RepositoryFactory from '@/repositories/RepositoryFactory'
const IndicatorRepository = RepositoryFactory.get('indicator')

export default {
    components: {
        IndicatorTable
    },
    
    data() {
        return {
            groups: [],
            groupList: [],
            totalItem: 0,
            tabsOrg: []
        }
    },

    created() {
        this.tabsOrg = OrganizationMachineTabMenu()
        this.getList()

        Bus.$on('search-indicator-group-list', () => {
            this.getList()
        })
    },

    beforeDestroy() {
        Bus.$off('search-indicator-group-list')
    },

    methods: {
        async getList() {
            const loading = this.$loading.show()
            const res = await IndicatorRepository.listGroup() 
            loading.hide()

            if (res.success) {
                this.groups = _.get(res, 'data', [])
                this.groupList = _.get(res, 'data', []).map(g => {
                    return {
                        id: g.id,
                        name: g.name
                    }
                })
                this.totalItem = _.get(res, 'totalItem', 0)
            } else {
                this.groups = []
                this.totalItem = 0
            }

        }
    }
}
</script>

<style scoped>
.indicator-container {
    background-color: white;
}
</style>